/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-12 18:27:28
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-14 15:20:56
 */
const agreement = [
    // 欢迎页
    {
        path: "/welcome",
        name: "agreementwelcome",
        component: () => import("../views/agreement/welcome.vue")
    },
    //协议列表
    {
        path: "/agreement/list",
        name: "agreementList",
        component: () => import("../views/agreement/list.vue")
    },
    //协议详情
    {
        path: "/agreement/detail/:typeCode",
        name: "agreementDetail",
        component: () => import("../views/agreement/detail.vue"),
        meta: {
            keepAlive: true
        }
    },
    //协议历史记录
    {
        path: "/agreement/history/:typeCode",
        name: "agreementHistory",
        component: () => import("../views/agreement/history.vue")
    },
    //协议历史记录
    {
        path: "/agreement/history/:typeCode",
        name: "agreementHistory",
        component: () => import("../views/agreement/history.vue")
    },
    //经营资质
    {
        path: "/agreement/qualification",
        name: "qualification",
        component: () => import("../views/agreement/qualification.vue")
    },
    //价格公示
    {
        path: "/agreement/price-show",
        name: "priceShow",
        component: () => import("../views/agreement/price-show.vue")
    }
];
export default agreement;



// WEBPACK FOOTER //
// ./src/router/agreement.js